import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { GoogleLoginComponent } from './google/googleLogin.component';
import { SigV4Service } from './aws/sigv4.service';
import { ImpersonationWarningComponent } from './raas/impersonationWarning.component';
import { FeaturePermissionsService } from './raas/featurePermissions.service';
import { AccessManagerService } from './accessManager/accessManager.service';
import { ApigeeService } from './apigee/apigee.service';
import { authInterceptor } from './apigee/auth.httpinterceptor';

@NgModule({
  declarations: [
    GoogleLoginComponent,
    ImpersonationWarningComponent
  ],
  exports: [
    GoogleLoginComponent,
    ImpersonationWarningComponent
  ], imports: [], providers: [
    ApigeeService,
    AccessManagerService,
    FeaturePermissionsService,
    SigV4Service,
    provideHttpClient(
      withInterceptors([
        authInterceptor
      ]),
      withInterceptorsFromDi()
    ),

  ]
})
export class AuthModule {
}
